// app/javascript/controllers/comment_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "content", "replyForm"]
  static values = {
    commentId: String,
    isReply: Boolean
  }
 
  connect() {
    
  }
  
  submit(event) {
    if (!this.contentTarget.value.trim()) {
      event.preventDefault()
      this.showError("Le commentaire ne peut pas être vide")
      return
    }
    
    // Marquons le formulaire comme soumis
    if (this.hasFormTarget) {
      this.formTarget.dataset.submitting = "true"
    }
  }

  // Renommé pour éviter toute confusion
  handleCommentSubmission(event) {
    // Trouve tous les formulaires marqués comme soumis
    const submittingForms = document.querySelectorAll('form[data-submitting="true"]')
    
    submittingForms.forEach(form => {
      // Réinitialiser le formulaire
      form.reset()
      
      // Vérifier si c'est un formulaire de réponse
      const turboFrame = form.closest('turbo-frame')
      if (turboFrame && turboFrame.id.startsWith('reply_form_')) {
        turboFrame.classList.add('hidden')
      }
      
      // Supprimer le marqueur
      form.removeAttribute('data-submitting')
    })
  }

  toggleReplyForm(event) {
    event.preventDefault()
    const commentId = event.target.closest('[data-comment-comment-id-value]').dataset.commentCommentIdValue
    const replyForm = document.getElementById(`reply_form_${commentId}`)
    
    if (replyForm) {
      replyForm.classList.toggle('hidden')
    }
  }

  cancelReply(event) {
    event.preventDefault()
    const replyForm = event.target.closest('turbo-frame')
    if (replyForm) {
      replyForm.classList.add('hidden')
    }
  }

  resetForm() {
    if (this.hasFormTarget) {
      this.formTarget.reset()
      if (this.hasContentTarget) {
        this.contentTarget.style.height = 'auto'
      }
    }
  }

  showError(message) {
    const errorDiv = document.createElement('div')
    errorDiv.classList.add('text-sm', 'text-red-600', 'mt-1')
    errorDiv.textContent = message
    this.contentTarget.parentNode.appendChild(errorDiv)
    setTimeout(() => errorDiv.remove(), 3000)
  }
}
